import { phone } from "phone";

window.productRegistrationPhone = phone;
